export const GET_PRIMARY = 'GET_PRIMARY';
export const START_CAPTURE = 'START_CAPTURE';
export const RESET_CAPTURE = 'RESET_CAPTURE';
